<app-back-header [headerText]="'Torna ai preventivi'" (backAction)="onCancel()" class="sticky-top">
</app-back-header>

<!-- I blocchi entrano uno dopo l'altro dall'alto (.izy-enter + ritardo per
     posizione, come in dashboard e nel dettaglio fattura): la pagina si compone
     invece di comparire tutta di scatto. -->
<div
  class="d-flex justify-content-between align-items-start mt-3 ms-1 mb-3 w-100 izy-enter"
  style="animation-delay: 0ms">
  <div>
    <h3 class="m-0">Dettaglio preventivo</h3>
    <p class="m-0 text-muted">I campi inseriti non sono modificabili.</p>
    <p class="m-0 mt-1 small text-muted">Preventivo per {{ displayDocumentType }}</p>
  </div>
</div>

<!-- La data di validita' e' il dato che distingue un preventivo da una
     fattura - e' quello che scade - quindi sta in cima come le chip di stato
     nel dettaglio fattura, e non come una riga di testo fra le altre. -->
<div class="d-flex align-items-center flex-wrap gap-2 ms-1 mb-3 izy-enter" style="animation-delay: 60ms">
  <span class="izy-validity-pill">
    <mat-icon>event_available</mat-icon>
    Valido fino a
    <strong>{{ invoiceForm.get('validity_date')?.value ? formatFormDate('validity_date') : '-' }}</strong>
  </span>
</div>

<div class="col-md-12 d-flex flex-column mb-3 izy-enter" style="animation-delay: 120ms">
  <mat-expansion-panel
    class="h-100 mt-md-0 mt-3 custom-card izy-sharp-bl"
    #panelclient>
      <mat-expansion-panel-header>
        <mat-panel-title>
          Cliente
        </mat-panel-title>
        <mat-panel-description>
          {{ company_name ? company_name : 'Nessuno' }}
          <span class="panel-state">{{ panelclient.expanded ? 'Chiudi' : 'Apri' }}</span>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="d-flex flex-column h-100 justify-content-center">

        <!-- Show when no company is selected -->
        <div *ngIf="!company_id" class="izy-empty-box text-center py-4">
          <mat-icon class="mb-2">face</mat-icon>
          <p class="mb-0">Nessun cliente selezionato</p>
        </div>

        <!-- I quattro dati del cliente in una riga sola: prima erano due righe
             annidate, ciascuna con la propria copia dello stato "nessun
             cliente". -->
        <div class="row">
          <div *ngIf="company_name" class="company-details w-sm-50">
            <div class="mb-3">
              <label class="form-label fw-bold text-secondary">Nome</label>
              <div class="p-2 bg-light rounded border">
                {{ company_name }}
              </div>
            </div>
          </div>

          <div *ngIf="company_iva_number" class="company-details w-sm-50">
            <div class="mb-3">
              <label class="form-label fw-bold text-secondary">Partita IVA</label>
              <div class="p-2 bg-light rounded border">
                {{ company_iva_number }}
              </div>
            </div>
          </div>

          <div *ngIf="company_address" class="company-details w-sm-50">
            <div class="mb-3">
              <label class="form-label fw-bold text-secondary">Indirizzo</label>
              <div class="p-2 bg-light rounded border">
                {{ company_address }}
              </div>
            </div>
          </div>

          <div *ngIf="company_addressee_code" class="company-details w-sm-50">
            <div class="mb-3">
              <label class="form-label fw-bold text-secondary">Codice SDI</label>
              <div class="p-2 bg-light rounded border">
                {{ company_addressee_code }}
              </div>
            </div>
          </div>
        </div>

      </div>

  </mat-expansion-panel>
</div>

<form [formGroup]="invoiceForm">
  <mat-expansion-panel
    class="mb-3 col-md-12 d-flex flex-column custom-card izy-sharp-bl izy-enter"
    style="animation-delay: 180ms"
    #panel
    >
      <mat-expansion-panel-header>
      <mat-panel-title>
        Documento
      </mat-panel-title>
      <mat-panel-description>
        Prev. {{ invoiceForm.get('progressive_number')?.value ? invoiceForm.get('progressive_number')?.value : 'n' }}/{{ invoiceForm.get('enumeration')?.value ? invoiceForm.get('enumeration')?.value : 'Anno' }}
        <span class="panel-state">{{ panel.expanded ? 'Chiudi' : 'Apri' }}</span>
      </mat-panel-description>
    </mat-expansion-panel-header>

      <div class="row">
        <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
          <mat-label>Numero progressivo</mat-label>
          <input matInput formControlName="progressive_number" readonly />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
          <mat-label>Numerazione</mat-label>
          <input matInput formControlName="enumeration" readonly />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
          <mat-label>Valuta</mat-label>
          <input matInput formControlName="currency" readonly />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
          <mat-label>Lingua</mat-label>
          <input matInput [value]="getLanguageDisplayName()" readonly />
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field appearance="outline" class="w-sm-50">
          <mat-label>Descrizione/Oggetto preventivo</mat-label>
          <textarea matInput formControlName="description" readonly></textarea>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-50">
          <mat-label>Note</mat-label>
          <textarea matInput formControlName="notes" readonly></textarea>
        </mat-form-field>
      </div>
  </mat-expansion-panel>

  <mat-expansion-panel
    class="mb-3 col-md-12 d-flex flex-column custom-card izy-sharp-bl izy-enter"
    style="animation-delay: 240ms"
    #panel2
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          Dettagli
        </mat-panel-title>
        <mat-panel-description>
          Creato il {{ formatFormDate('emission_date') }}
          <span class="panel-state">{{ panel2.expanded ? 'Chiudi' : 'Apri' }}</span>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="row">
        <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Data di emissione</mat-label>
          <input
            matInput
            formControlName="emission_date"
            readonly
            [value]="formatFormDate('emission_date')"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Data di pagamento</mat-label>
          <input
            matInput
            formControlName="payment_date"
            readonly
            [value]="formatFormDate('payment_date')"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
          <mat-label>Marca da bollo</mat-label>
          <input matInput formControlName="revenue_stamp" readonly />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
          <mat-label>Marca da bollo a carico del cliente</mat-label>
          <input
            matInput
            [value]="getBooleanDisplay(invoiceForm.get('revenue_stamp_for_company')?.value)"
            readonly
          />
        </mat-form-field>
      </div>
  </mat-expansion-panel>

  <mat-expansion-panel
    class="mb-3 col-md-12 d-flex flex-column custom-card izy-sharp-bl izy-enter"
    style="animation-delay: 300ms"
    #panel3
    >
      <mat-expansion-panel-header>
          <mat-panel-title>
            Prestazioni
          </mat-panel-title>
          <mat-panel-description>
            Aggiunte: <span class="article-badge">{{ productServices.length }}</span>
            <span class="panel-state">{{ panel3.expanded ? 'Chiudi' : 'Apri' }}</span>
          </mat-panel-description>
        </mat-expansion-panel-header>

      <div class="hidden-mobile">

       <!-- Products and services table -->
      <div *ngIf="isLoadingProducts" class="loading-container">
        <p>Caricamento prodotti/servizi...</p>
      </div>

      <div *ngIf="!isLoadingProducts && productServices.length === 0" class="no-data-container">
        <mat-icon>sentiment_neutral</mat-icon>
        <p>Nessun prodotto o servizio associato a questo preventivo.</p>
      </div>

      <div *ngIf="!isLoadingProducts && productServices.length > 0" class="table-container">
        <table mat-table [dataSource]="productServices">

          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef> Nome </th>
            <td mat-cell *matCellDef="let product"> {{product.name}} </td>
          </ng-container>

          <!-- Quantity Column -->
          <ng-container matColumnDef="quantity">
            <th mat-header-cell *matHeaderCellDef> Quantità </th>
            <td mat-cell *matCellDef="let product"> {{product.quantity}} </td>
          </ng-container>

          <!-- Units Column -->
          <ng-container matColumnDef="units">
            <th mat-header-cell *matHeaderCellDef> Unità </th>
            <td mat-cell *matCellDef="let product"> {{product.units}} </td>
          </ng-container>

          <!-- Gross Amount Column -->
          <ng-container matColumnDef="gross_amount">
            <th mat-header-cell *matHeaderCellDef> Importo Lordo </th>
            <td mat-cell *matCellDef="let product"> {{product.gross_amount | currency:'EUR'}} </td>
          </ng-container>

          <!-- Discount Column -->
          <ng-container matColumnDef="discount">
            <th mat-header-cell *matHeaderCellDef> Sconto (%) </th>
            <td mat-cell *matCellDef="let product"> {{product.discount}}% </td>
          </ng-container>

          <!-- IVA Percentage Column -->
          <ng-container matColumnDef="iva_percentage">
            <th mat-header-cell *matHeaderCellDef> IVA (%) </th>
            <td mat-cell *matCellDef="let product"> {{product.iva_percentage}}% </td>
          </ng-container>

          <!-- IVA Amount Column -->
          <ng-container matColumnDef="iva_amount">
            <th mat-header-cell *matHeaderCellDef> Importo IVA </th>
            <td mat-cell *matCellDef="let product"> {{product.iva_amount | currency:'EUR'}} </td>
          </ng-container>

          <!-- Final Amount Column -->
          <ng-container matColumnDef="final_amount">
            <th mat-header-cell *matHeaderCellDef> Totale </th>
            <td mat-cell *matCellDef="let product"> {{product.final_amount | currency:'EUR'}} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>

      <!-- Summary of product services -->
      <div *ngIf="!isLoadingProducts && productServices.length > 0" class="product-summary mt-2 mb-1">
        <div class="summary-item">
          <span class="label">Totale prodotti/servizi:</span>
          <span class="value">{{ getTotalProductServices() | currency:'EUR' }}</span>
        </div>
        <div class="izy-divider-h"></div>
        <div class="summary-item">
          <span class="label">Numero voci:</span>
          <span class="value">{{ productServices.length }}</span>
        </div>
      </div>

    </div>

    <!-- mobile cards -->
    <div class="visible-mobile">
       <h6 class="mt-2">Prodotti e servizi:</h6>

      <!-- Mobile loading state -->
      <div *ngIf="isLoadingProducts" class="loading-container">
        <p>Caricamento prodotti/servizi...</p>
      </div>

      <!-- Mobile empty state -->
      <div *ngIf="!isLoadingProducts && productServices.length === 0" class="no-data-container">
        <mat-icon>sentiment_neutral</mat-icon>
        <p>Nessun prodotto o servizio associato a questo preventivo.</p>
      </div>

      <!-- Mobile product cards -->
      <div *ngIf="!isLoadingProducts && productServices.length > 0" class="mobile-products-container">
        <mat-card *ngFor="let product of productServices" class="product-card izy-sharp-bl mb-2">
          <mat-card-header class="pb-2">
            <mat-card-title class="product-name">{{ product.name }}</mat-card-title>
          </mat-card-header>

          <mat-card-content class="product-details">
            <div class="detail-row">
              <span class="label">Quantità:</span>
              <span class="value">{{ product.quantity }} {{ product.units }}</span>
            </div>

            <div class="detail-row">
              <span class="label">Importo lordo:</span>
              <span class="value">{{ product.gross_amount | currency:'EUR' }}</span>
            </div>

            <div class="detail-row" *ngIf="product.discount">
              <span class="label">Sconto:</span>
              <span class="value">{{ product.discount }}%</span>
            </div>

            <div class="detail-row">
              <span class="label">IVA:</span>
              <span class="value">{{ product.iva_percentage }}% ({{ product.iva_amount | currency:'EUR' }})</span>
            </div>

            <div class="izy-divider-h my-2"></div>

            <div class="detail-row total">
              <span class="label">Totale:</span>
              <span class="value">{{ product.final_amount | currency:'EUR' }}</span>
            </div>
          </mat-card-content>
        </mat-card>

        <!-- Mobile summary -->
        <div class="product-summary mt-3">
          <div class="izy-divider-h"></div>
          <div class="summary-item">
            <span class="label">Totale prodotti/servizi:</span>
            <span class="value">{{ getTotalProductServices() | currency:'EUR' }}</span>
          </div>
          <div class="izy-divider-h"></div>
          <div class="summary-item">
            <span class="label">Numero voci:</span>
            <span class="value">{{ productServices.length }}</span>
          </div>
        </div>
      </div>
    </div>

  </mat-expansion-panel>

  <mat-card
    class="mb-3 col-md-12 d-flex flex-column custom-card izy-sharp-bl izy-enter"
    style="animation-delay: 360ms">
    <mat-card-content>
      <h4 class="m-2">Riepilogo:</h4>

      <mat-divider></mat-divider>
      <div class="summary-item">
        <span class="fw-medium">Competenze:</span>
        <span class="fw-medium">{{ invoiceForm.get('gross_amount')?.value | currency:'EUR' }}</span>
      </div>

      <div class="summary-item">
        <span class="label">Marca da bollo:</span>
        <span class="value"> {{ invoiceForm.get('revenue_stamp')?.value | currency:'EUR' }}</span>
      </div>

      <div class="summary-item" *ngIf="invoiceForm.get('discount_amount')?.value > 0">
        <span class="label">Sconto:</span>
        <span class="value">
          - {{ invoiceForm.get('discount_amount')?.value | currency:'EUR' }}
        </span>
      </div>

      <mat-divider *ngIf="invoiceForm.get('revenge')?.value > 0"></mat-divider>
      <div class="summary-item" *ngIf="invoiceForm.get('revenge')?.value > 0">
        <span class="label">
          Rivalsa ({{invoiceForm.get('revenge_rate')?.value}}%):
        </span>
        <span class="value">
          + {{ invoiceForm.get('revenge')?.value | currency:'EUR' }}
        </span>
      </div>

      <mat-divider *ngIf="invoiceForm.get('pension_fund')?.value > 0"></mat-divider>
      <div class="summary-item" *ngIf="invoiceForm.get('pension_fund')?.value > 0">
        <span class="label">
          Cassa previdenziale ({{invoiceForm.get('pension_fund_rate')?.value}}%):
        </span>
        <span class="value">
          + {{ invoiceForm.get('pension_fund')?.value | currency:'EUR' }}
        </span>
      </div>
      <span class="ms-2 small text-muted" *ngIf="invoiceForm.get('pension_fund')?.value > 0">
         {{ getPensionFundDisplayName() }}
      </span>

      <mat-divider></mat-divider>
      <div class="summary-item">
        <span class="fw-medium">Imponibile:</span>
        <span class="fw-medium">{{ invoiceForm.get('taxable_amount')?.value | currency:'EUR' }}</span>
      </div>

      <mat-divider></mat-divider>
      <div class="summary-item">
        <span class="label">Iva ({{invoiceForm.get('iva_percentage')?.value}}%):</span>
        <span class="value">+ {{ invoiceForm.get('iva_amount')?.value | currency:'EUR' }}</span>
      </div>

      <mat-divider *ngIf="invoiceForm.get('withholding_advance_tax')?.value > 0"></mat-divider>
      <div class="summary-item" *ngIf="invoiceForm.get('withholding_advance_tax')?.value > 0">
        <span class="label">
          Ritenuta d'acconto ({{invoiceForm.get('withholding_advance_tax_rate')?.value}}%):
        </span>
        <span class="value">
          - {{ invoiceForm.get('withholding_advance_tax')?.value | currency:'EUR' }}
        </span>
      </div>

      <mat-divider *ngIf="invoiceForm.get('withholding_tax')?.value > 0"></mat-divider>
      <div class="summary-item" *ngIf="invoiceForm.get('withholding_tax')?.value > 0">
        <span class="label">
          Ritenuta ({{invoiceForm.get('withholding_tax_rate')?.value}}%):
        </span>
        <span class="value">
          - {{ invoiceForm.get('withholding_tax')?.value | currency:'EUR' }}
        </span>
      </div>

      <div class="summary-item total">
        <span class="label">Totale da incassare:</span>
        <span class="value">{{ invoiceForm.get('amount')?.value | currency:'EUR' }}</span>
      </div>
    </mat-card-content>
  </mat-card>
</form>

<!-- ---- Azioni ----
     Una sola azione primaria per schermata (petrol pieno): qui e' l'export del
     PDF, il motivo per cui si apre un preventivo gia' emesso. Tutto il resto e'
     secondario: pillola bianca bordata nera (.izy-button-ghost +
     .custom-button-border). -->
<div class="pb-3 izy-enter" style="animation-delay: 420ms">

  <!-- Versione Desktop -->
  <div class="hidden-mobile d-flex flex-wrap justify-content-end gap-2 mb-3">
    <button
      mat-stroked-button
      class="izy-button-primary custom-button-border"
      (click)="downloadPdf(invoiceId)"
    >
      <mat-icon>print</mat-icon>
      Scarica PDF
    </button>
    <button
      mat-stroked-button
      class="izy-button-ghost custom-button-border"
      (click)="downloadXml()"
    >
      <mat-icon>download</mat-icon>
      Download XML
    </button>
    <button
      mat-stroked-button
      class="izy-button-ghost custom-button-border"
      (click)="sendInvoiceEmail()"
    >
      <mat-icon>outgoing_mail</mat-icon>
      Invia preventivo per email
    </button>
  </div>

  <!-- Versione Mobile: le stesse azioni a tutta larghezza, una per riga, con le
       etichette per esteso - abbreviarle in "PDF" e "XML" faceva risparmiare
       spazio quando stavano affiancate, ma qui lo spazio c'e'. -->
  <div class="visible-mobile mb-3">
    <button
      mat-stroked-button
      class="w-100 mb-2 izy-button-primary custom-button-border"
      (click)="downloadPdf(invoiceId)"
    >
      <mat-icon>print</mat-icon>
      Scarica PDF
    </button>
    <button
      mat-stroked-button
      class="w-100 mb-2 izy-button-ghost custom-button-border"
      (click)="downloadXml()"
    >
      <mat-icon>download</mat-icon>
      Download XML
    </button>
    <button
      *ngIf="invoiceForm.get('is_draft')?.value == false"
      mat-stroked-button
      class="w-100 izy-button-ghost custom-button-border"
      (click)="sendInvoiceEmail()"
    >
      <mat-icon>outgoing_mail</mat-icon>
      Invia preventivo per email
    </button>
  </div>

</div>
